export default class WeatherData{
    constructor(place, temperature_2m, windspeed_10m,is_day,relativehumidity_2m,weathercode) {
        this.place = place;
        this.temperature_2m = temperature_2m;
        this.windspeed_10m = windspeed_10m;
        this.is_day = is_day;
        this.relativehumidity_2m = relativehumidity_2m;
        this.weathercode= weathercode;
    }
}